import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { TextColorEnum } from '~/cms/enums/text-color.enum';
import { BannerCms } from '~/cms/interfaces/homepage.cms.interface';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';

import { CtaVariantEnum } from '~/component/call-to-action/enums/variant.enum';
import { CtaWidthEnum } from '~/component/call-to-action/enums/width.enum';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';

@Component({
  selector: 'app-attendee-banner',
  templateUrl: './banner.component.html',
})
export class AttendeeBannerComponent implements OnDestroy, OnInit {
  @Input() public banner: BannerCms;
  @Input() public isHp?: boolean;

  private readonly subscriptions = new Subscription();

  public readonly ctaVariant = CtaVariantEnum;
  public readonly ctaWidth = CtaWidthEnum;
  public readonly VtmnPlayButtonSize = VtmnPlayButtonSizeEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;

  public isMobileDevice: boolean;

  constructor(private readonly matchMediaService: MatchMediaService) {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }

  public get isTextColorWhite(): boolean {
    return TextColorEnum.WHITE === this.banner.textColor;
  }
}
